exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-large-body {\n\tmin-height: 480px;\n}\n.expense-mobile-icon-list {\n\tpadding: 0 !important;\n}\n.expense-mobile-icon-list .label {\n\tfont-size: 0.8rem;\n\tline-height: 1.1;\n}\n.my-expense-mobile-view-component-wrapper {\n\tmargin-top: 1.5rem;\n}\n.spacing-screen {\n\tmargin-left: -10px;\n\tmargin-right: -10px;\n}\n.position {\n\tpadding: 14px;\n\tborder-radius: 50%;\n}\n.border-style {\n\tborder-radius: 10px;\n}\n.spacing-pad {\n\tpadding: 10px;\n}\n", ""]);

// exports
